/**
 * Truck API Schemas
 *
 * Zod validation schemas for truck-related API operations
 */

import { z } from "zod";

import { REGEX } from "@/lib/zod";

/**
 * Schema for creating/updating a truck
 */
export const createTruckArgsSchema = z.object({
  id: z.string().or(z.number()).optional().nullable(),
  color: z.string().min(1, "Cor é obrigatória"),
  licensePlate: z.string().min(1, "Placa é obrigatória"),
  // licensePlate: z.string().min(1, "Placa é obrigatória").regex(REGEX.PLATE, "Placa inválida"),
  renavam: z.string().regex(REGEX.RENAVAM, "Renavam inválido").min(1, "Renavam é obrigatório"),
  owner: z.string().optional(),
  shippingCompany: z
    .object({
      id: z.string().nullable()
    })
    .nullable(),
  vehicleModel: z.object({
    id: z.string("Modelo do veículo é obrigatório")
  }),
  brand: z
    .object({
      id: z.string("Marca é obrigatória").optional()
    })
    .optional(),
  driver: z
    .object({
      id: z.string()
    })
    .nullable(),
  company: z.object({
    id: z.string("Empresa é obrigatória").nullable()
  }),
  implementType: z.string("Tipo de implemento é obrigatório"),
  shaftQuantity: z.number("Quantidade de eixos é obrigatória").min(1, "Quantidade de eixos é obrigatória"),
  grossCapacity: z.number("Capacidade bruta é obrigatória").min(1, "Capacidade bruta é obrigatória"),
  netCapacity: z.number("Capacidade líquida é obrigatória").min(1, "Capacidade líquida é obrigatória"),
  isEnabled: z.boolean(),
  holder: z.string().optional(),
  name: z.string().optional(),
  cpf: z.string().optional(),
  contact: z
    .array(
      z
        .object({
          id: z.number().nullable(),
          name: z.string().min(1, "Nome é obrigatório"),
          fone: z.string().min(1, "Telefone é obrigatório"),
          email: z.email("Email inválido")
        })
        .partial()
    )
    .optional()
});

/**
 * Schema for rebinding a truck
 */
export const rebindTruckArgsSchema = z.object({
  truck: z.object({
    driver: z.object({ id: z.number() }),
    licensePlate: z.string(),
    renavam: z.string(),
    vehicleModel: z.object({
      id: z.number(),
      truckBrand: z.object({ id: z.number() })
    }),
    color: z.string(),
    company: z.object({ id: z.number() }),
    shippingCompany: z.object({ id: z.number() }).optional(),
    grossCapacity: z.number(),
    implementType: z.string(),
    netCapacity: z.number(),
    owner: z.string(),
    shaftQuantity: z.number()
  })
});
